import './DelayTime.scss'

import classNames from 'classnames'
import { format } from 'date-fns'
import React from 'react'
import { calculatePercentage } from 'utils/math'

export interface DelayTimeProps {
  duration: number
  delay?: number
  time: Date
  className?: string
}

export default function DelayTime({
  duration,
  time,
  delay,
  className,
}: DelayTimeProps): JSX.Element {
  const formattedTime = format(time, 'HH:mm')
  const delayTimeClass = getDelayColorClass(duration, delay, 'DelayTime__delay--traffic-')
  return <div className={classNames(className, 'DelayTime', delayTimeClass)}>{formattedTime}</div>
}

export function getDelayColorClass(
  duration: number | undefined,
  delay: number | undefined,
  prefixClass: string
): string {
  if (duration !== undefined && delay !== undefined) {
    if (delay === 0) {
      return prefixClass + 'low'
    }
    const delayPercentage = calculatePercentage(duration, delay)
    if (delayPercentage) {
      const delayColorClass = delayPercentage !== undefined ? prefixClass + 'medium' : ''
      return delayColorClass
    }
  }
  return ''
}
